import { useRef, useState } from "react";

const events = [
  { date: "Apr 23", title: "World Book Day", desc: "A celebration of reading and storytelling with activities and book fair.", image: "https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621364/event1_zjndbs.jpg"},
  { date: "May 8", title: "Mother’s Day Celebration", desc: "Students present performances and handmade gifts for moms.", image: "https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621368/event2_l8beuc.jpg"},
  { date: "Jun 5", title: "World Environment Day", desc: "Tree planting drive and eco-awareness sessions across classes.", image: "https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755622231/event3_r7dwsg.jpg"},
  { date: "Jul 15", title: "Science Exhibition", desc: "Hands-on experiments and models by students from all grades.", image: "https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621374/event4_ot5sas.jpg"},
  { date: "Aug 15", title: "Independence Day", desc: "Flag hoisting and patriotic performances by students.", image: "https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621364/event5_mrlxg8.jpg"},
  { date: "Sep 5", title: "Teachers’ Day", desc: "A day of gratitude with fun activities and student-led assemblies.", image: "https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621381/event6_wvpvyi.jpg"},
  { date: "Oct 24", title: "Dussehra Celebration", desc: "Traditional dress, Ramayana skits, and cultural performances.", image: "https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621368/event7_pel97j.jpg"},
  { date: "Nov 14", title: "Children’s Day", desc: "Carnival, games, and a surprise show from the teachers!", image: "https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621371/event8_ntqsjc.jpg"},
  { date: "Dec 20", title: "Christmas Celebration", desc: "Carols, skits, and secret Santa fun to spread holiday cheer!", image: "https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621377/event9_eppr7g.jpg"},
];

const UpcomingEvents = () => {
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);

  const scroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
      const scrollAmount = 300;
      const newScrollLeft =
        direction === "left"
          ? current.scrollLeft - scrollAmount
          : current.scrollLeft + scrollAmount;

      current.scrollTo({ left: newScrollLeft, behavior: "smooth" });

      setTimeout(() => {
        if (current.scrollLeft > 0) {
          setShowLeftArrow(true);
        } else {
          setShowLeftArrow(false);
        }
      }, 300);
    }
  };

  const handleScroll = () => {
    if (scrollRef.current) {
      setShowLeftArrow(scrollRef.current.scrollLeft > 0);
    }
  };

  return (
    <section 
      className="bg-fixed bg-cover bg-center py-10 relative"
      style={{ backgroundImage: `url(https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755622231/bg-ue_zpnuiy.jpg)` }}
    >
      <div className="rounded-xl p-8 mx-auto max-w-7xl">
        <h2 className="text-5xl font-bold text-left text-schoolylw mb-20 ml-10">Upcoming Events</h2>

        <div className="relative mb-10">
          {/* Left Arrow Button (conditionally shown) */}
          {showLeftArrow && (
            <button
              onClick={() => scroll("left")}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 
                        bg-black/60 text-white backdrop-blur-md 
                        p-3 rounded-full shadow-lg hover:scale-110 
                        transition duration-300 hover:bg-black/80"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}

          {/* Right Arrow Button */}
          <button
            onClick={() => scroll("right")}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 
                        bg-black/60 text-white backdrop-blur-md 
                        p-3 rounded-full shadow-lg hover:scale-110 
                        transition duration-300 hover:bg-black/80"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {/* Horizontal Gallery */}
          <div
            ref={scrollRef}
            onScroll={handleScroll}
            className="flex gap-12 overflow-x-auto no-scrollbar scroll-smooth px-6"
          >
            {events.map((event, idx) => (
              <div
                key={idx}
                className="min-w-[250px] max-w-[300px] bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden text-left"
              >
                <div className="relative">
                  <img src={event.image} alt={event.title} className="h-40 w-full object-cover" loading="lazy"/>
                  <div className="absolute top-0 left-0 bg-[#C86E6E] text-white px-4 py-1 rounded-br-xl shadow text-sm text-center">
                    <span className="block text-xs font-bold uppercase">{event.date.split(" ")[0]}</span>
                    <span className="block text-lg font-bold">{event.date.split(" ")[1]}</span>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-lg font-semibold text-schoolBlue">{event.title}</h3>
                  <p className="text-sm text-gray-700 mt-2">{event.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvents;
